export const config: typeof window.__CONFIG__ = {
  SERVICE_NAME: window.__CONFIG__.SERVICE_NAME,
  ENV_NAME: window.__CONFIG__.ENV_NAME,
  API_BASE_URL: window.__CONFIG__.API_BASE_URL,
  VGS_COLLECT_VAULT_ID: window.__CONFIG__.VGS_COLLECT_VAULT_ID,
  VGS_ENV: window.__CONFIG__.VGS_ENV,
  VGS_COLLECT_VERSION: window.__CONFIG__.VGS_COLLECT_VERSION,
  VGS_COLLECT_ROUTE_ID: window.__CONFIG__.VGS_COLLECT_ROUTE_ID,
  VGS_PROXY_VAULT_ID: window.__CONFIG__.VGS_PROXY_VAULT_ID,
  THEME: window.__CONFIG__.THEME,
  KENTUCKY_API_BASE_URL: window.__CONFIG__.KENTUCKY_API_BASE_URL,
  GOOGLE_MAP_API_KEY: window.__CONFIG__.GOOGLE_MAP_API_KEY,
  AWS_REGION: window.__CONFIG__.AWS_REGION || "us-east-1",
  TRANSFER_FLAVOR: window.__CONFIG__.TRANSFER_FLAVOR || "A",
  THEME_MODE: window.__CONFIG__.THEME_MODE || "",
  POSTHOG_KEY: window.__CONFIG__.POSTHOG_KEY || "",
  POSTHOG_HOST: window.__CONFIG__.POSTHOG_HOST || "https://us.i.posthog.com",
  QUOTE_DEBOUNCE_MS: window.__CONFIG__.QUOTE_DEBOUNCE_MS ?? 1000,
};
